import { GeneralCountryInformationTypeResponse } from 'src/app/web-api-client';
import { InformationType } from '../models/information-type';

export const mapInformationTypeFromResponse = (
  item: GeneralCountryInformationTypeResponse
): InformationType => {
  return new InformationType({
    generalCountryInformationTypeId: item.generalCountryInformationTypeId,
    name: item.name,
  });
};
